<template>
  <div class="container-fluid">
    <div id="topo" class="card-header">
      <div class="row">
        <div class="col col-xs-2">
          <h4 class="panel-title">
            <span class="title">Consulta Notas Fiscais Integração Nota Nacional</span>
            <br />
            <span class="navigation">Notas Fiscais Integração Nota Nacional > Consulta{{ isEmissaoTesteValidacao ?
              '(Teste e Validação)' : ''}}</span>
          </h4>
        </div>
      </div><!--row-->
    </div><!--card-header-->

    <div class="card-body">
      <div class="row">
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <Calendar id="dataIni" name="dataFim" v-model="dataEmissaoIni" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <Calendar id="dataFim" name="dataFim" v-model="dataEmissaoFin" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Data Final" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <InputText id="chave" name="chave" v-model="chave" placeholder="Chave Nfse Nacional"
              @keyup.enter="pesquisar" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <InputText id="documentoPrestador" name="documentoPrestador" v-model="documentoPrestador"
              placeholder="Doc. Prestador" @keyup.enter="pesquisar" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <InputText id="numeroNfse" name="numeroNfse" v-model="numeroNfse" placeholder="Número NFSe"
              @keyup.enter="pesquisar" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <Dropdown id="situacao" v-model="selectedSituacaoTransmissao" :options="situacoesTransmissao"
            optionLabel="name" placeholder="Selecione uma Situação" />
        </div>
        <div class="col-md-3 col-lg-5 mb-3">
          <Button label="Pesquisar" title="Pesquisar" type="button" icon="pi pi-search" :disabled="loading"
            @click="pesquisar()" class="mr-2"/>

          <Button label="Reprocessar Notas com Erros" title="Reprocessar Notas com Erros" type="button"
            icon="pi pi-check" :disabled="loading" @click="reprocessarGeral()" />
        </div>
      </div>
      <div class="row">
        <DataTable :value="notaNacionalList" :paginator="true" :rows="10" class="p-datatable-responsive"
          :autoLayout="true">
          <template #empty>
            <tr class="p-datatable-empty">
              <td>Informe os dados para pesquisa!</td>
            </tr>
          </template>
          <Column header="Imprimir Nota Fiscal" headerStyle="width: 12em" bodyStyle="text-align: center">
            <template #body="slotProps">
              <Button type="button" icon="pi pi-print" label="Visualizar"
                @click="visualizar(slotProps.data.idNfse)"></Button>
            </template>
          </Column>
          <Column header="Reprocessar" headerStyle="width: 12em" bodyStyle="text-align: center">
            <template #body="slotProps">
              <Button type="button" icon="pi pi-refresh" label="Reprocessar"  v-if="slotProps.data.jsonRetorno && slotProps.data.transmitidoNacional === 'Erro'"
                @click="reprocessar(slotProps.data.idNfse)"></Button>
            </template>
          </Column>
          <Column header="Visualizar Erros" headerStyle="width: 12em" bodyStyle="text-align: center">
            <template #body="slotProps">
              <Button v-if="slotProps.data.jsonRetorno && slotProps.data.transmitidoNacional === 'Erro'" type="button"
                icon="pi pi-file-excel" label="Erros" @click="openWindowErros(slotProps.data.jsonRetorno)"></Button>
            </template>
          </Column>
          <Column field="numero" header="Número NFSe"></Column>
          <Column field="chaveNfse" header="Chave NFSe"></Column>
          <Column field="dataTransmissaoFormatada" header="Data Transmissão"></Column>
          <Column field="documento" header="Documento Prestador"></Column>
          <Column field="nome" header="Prestador"></Column>
          <Column field="inscMunic" header="Inscrição"></Column>
          <Column field="transmitidoNacional" header="Transmitido"></Column>
        </DataTable>
      </div>
      <hr />
      <template>
        <router-link to="/consultaNfse">
          <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
            icon="pi pi-arrow-left"></Button>
        </router-link>
      </template>
    </div>



    <Dialog header="Erro Nota RPS" :contentStyle="{ overflow: 'visible' }" :visible.sync="showErros"
      :style="{ width: '70vw' }" :modal="true">
      <h1 class="titulo-header">
        Erros Transmissão Nota Nacional
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showErros = false" />
      </h1><br />
      <template>
        <p>
        <pre>{{ jsonErro }}</pre>
        </p>
      </template>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="closeWindowErros()" title="Não" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Processar novo Lote Rps" :visible.sync="showNovoLote" :style="{ width: '40vw' }" :modal="true">
      <h1 class="titulo-header">
        Processar novo Lote Rps
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showNovoLote = false" />
      </h1><br />
      <div class="card-body">
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="file">Selecione o Tipo do Envio: </label>
            <br />
            <Dropdown id="tipo" v-model="selectedTipo" :options="tipos" optionLabel="name"
              placeholder="Selecione um Tipo de Envio" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="file">Anexar abaixo o XML: </label>
            <br />
            <span class="p-fluid">
              <input type="file" id="files" ref="files" v-on:change="handleFileUploads()" />
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Processar" icon="pi pi-check" @click="processarLote()" class="mr-2" />
            <Button label="Fechar" icon="pi pi-times" @click="showNovoLote = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog header="Nota Fiscal Referente ao Lote RPS" :contentStyle="{ overflow: 'visible' }"
      :visible.sync="showTelaNota" :style="{ width: '70vw' }" :modal="true">
      <h1 class="titulo-header">
        Nota Fiscal Referente ao Lote RPS
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showTelaNota = false" />
      </h1><br />
      <div class="row">
        <div class="col-md-3 mb-2">
          <label for="lote" style="font-weight: bold;">Lote:</label>
          <span class="p-fluid">
            <InputText type="text" disabled title="Lote" v-model="showchave" />
          </span>
        </div>
        <div class="col-md-4 mb-2">
          <label for="protocolo" style="font-weight: bold;">Protocolo:</label>
          <span class="p-fluid">
            <InputText type="text" disabled title="Protocolo" v-model="showProtocolo" />
          </span>
        </div>
      </div>
      <hr />
      <DataTable :value="notasList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
        <template #header>
          <div class="table-header" style="text-transform: uppercase; font-weight: bold; text-align: center;">
            Notas Geradas
          </div>
        </template>
        <Column header="Imprimir Nota Fiscal" headerStyle="width: 12em" bodyStyle="text-align: center">
          <template #body="slotProps">
            <Button type="button" icon="pi pi-print" label="Visualizar" @click="visualizar(slotProps.data.id)"></Button>
          </template>
        </Column>
        <Column field="numero" header="Número NFS-e"></Column>
        <Column field="rpsNumero" header="Número RPS"></Column>
        <Column field="rpsSerie" header="Série RPS"></Column>
        <Column field="rpsTipo" header="Tipo RPS"></Column>
        <Column field="dataEmissaoFormatada" header="Data Emissão"></Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="closeWindowNota()" title="Não" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
  </div><!--container-fluid-->
</template>

<script>
/* eslint-disable */
import LoginService from "../services/acesso/login.service";
import NotaFiscalNacionalService from '../services/nfse/notafiscalnacional.service';
import NotaFiscalService from '../services/nfse/notafiscal.service';
import ReportService from "../services/report.service";

export default {
  name: 'ConsultaNfseRps',
  props: {
    testeValidacao: Boolean
  },
  data() {
    return {
      loading: false,
      display: false,
      search: false,
      lote: null,
      notaNacionalList: [],
      notasList: [],
      currentUser: null,
      dataEmissaoIni: null,
      dataEmissaoFin: null,
      showErros: false,
      jsonErro: null,
      desabilitaErrosRps: true,
      chave: null,
      numeroNfse: null,
      documentoPrestador: null,
      showNovoLote: false,
      selectedTipo: null,
      selectedSituacaoTransmissao: null,
      tipos: [
        { name: "EnviarLoteRps", key: "E" },
        { name: "EnviarLoteRpsSincrono", key: "S" },
        { name: "GerarNfse", key: "G" }
      ],
      situacoesTransmissao: [
        { name: "Todos", key: "T" },
        { name: "Sucesso", key: "S" },
        { name: "Erro", key: "E" }
      ],
      files: "",
      showTelaNota: false,
      idRps: null,
      showchave: null,
      showProtocolo: null,
      observacaoClienteNfse: false
    }
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.dataEmissaoIni = new Date();
    this.dataEmissaoIni.setDate(this.dataEmissaoIni.getDate() - 30);
    this.dataEmissaoFin = new Date();
    this.selectedTipo = this.tipos[0];
    this.selectedSituacaoTransmissao = this.situacoesTransmissao[0];
    this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === "S";
  },

  methods: {

    pesquisar() {
      this.processando(true);
      let msg = null;

      if (!this.dataEmissaoIni) {
        msg = "É necessário selecionar uma data de emissão inicial";
      }

      if (!this.dataEmissaoFin) {
        msg = "É necessário selecionar uma data de emissão final";
      }

      if (!msg) {
        this.search = true;
        NotaFiscalNacionalService.findAllNotas(
          this.currentUser.usuario.idCliente,
          this.dataEmissaoIni,
          this.dataEmissaoFin,
          this.chave,
          this.numeroNfse,
          this.documentoPrestador,
          this.selectedSituacaoTransmissao.key,
          this.isEmissaoTesteValidacao ? 'R' : 'P'
        ).then(
          (response) => {
            this.notaNacionalList = response;
          },
          error => {
            let errorMessage = "Houve um problema ao listar Notas Fiscais!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        ).then(() => {
          this.processando(false);
          this.search = false;
        });

      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    openWindowErros(jsonRetorno) {
      this.jsonErro = null;
      if ((jsonRetorno === null || jsonRetorno === "")) {
        this.$root.$emit("alert:warn", 'Não existem erros para serem exibidos!');
      } else {
        this.jsonErro = JSON.stringify(JSON.parse(jsonRetorno), null, 2);
        this.showErros = true;
      }
    },
    closeWindowErros() {
      this.showErros = false;
    },


    visualizar(nfseId) {
      this.processando(true);

      let nomeRel = (this.isEmissaoTesteValidacao ? 'NotaFiscalEletronicaTeste' : (this.observacaoClienteNfse ? "NotaFiscalEletronicaObs" : "NotaFiscalEletronica"));

      ReportService.imprimir(nomeRel, [
        {
          param: "where",
          string: " and nota_fiscal.id = '" + nfseId + "' ",
        }

      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    reprocessar(nfseId) {
      this.processando(true);

      NotaFiscalNacionalService.reprocessar(nfseId, this.isEmissaoTesteValidacao ? 'R' : 'P')
        .then(
          (data) => {
            this.$root.$emit("alert:warn", "Nfse marcada para reprocessar!");
            this.pesquisar();
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao marcar nota para reprocessar!");
            console.log(error);
          }
        )
        .then(() => {
          
          this.processando(false);
        });
    },
    reprocessarGeral() {
      this.processando(true);

      NotaFiscalNacionalService.reprocessarGeral(this.currentUser.usuario.idCliente,
          this.dataEmissaoIni,
          this.dataEmissaoFin,
          this.chave,
          this.numeroNfse,
          this.documentoPrestador,
          this.isEmissaoTesteValidacao ? 'R' : 'P')
        .then(
          (data) => {
            this.$root.$emit("alert:warn", "Listagem de Nfse com erro marcadas para reprocessar!");
            this.pesquisar();
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao marcar Listagem de Nfse com erro para reprocessar!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  },

  computed: {

    isEmissaoTesteValidacao() {
      return this.testeValidacao
    },

  },
};
</script>
